import React from 'react';
import { observer } from "mobx-react-lite";
// import classNames from 'classnames';
import { Layout, Loading } from '@jdcfe/legao';
import useStores from 'stores';
import { AclRoutes } from 'routes';
import VopHeader from 'components/vop_header';
import AppHeader from 'components/AppHeader';
// import logo from 'src/logo.svg';

import './style.scss';

const { Container, Content, Header, Main } = Layout;

const BasicLayout = observer(({ route }) => {
  const { basicStore } = useStores();

  return (
    <div className="basic-layout">
      <Layout className="lg-layout-row">
        <Header>
          <VopHeader contentWidth="calc(100% - 28px)">
            <AppHeader></AppHeader>
          </VopHeader>
        </Header>
        <Main>
          <Container>
            <Content className="lg-layout-inner basic-layout-content">
              <div className="basic-layout-content-inner">
                {<AclRoutes watchQuery routes={route.routes} authorities="" />}
              </div>
            </Content>
          </Container>
        </Main>
        {
          basicStore.loading && (
            <div className="basic-layout-loading">
              <Loading />
            </div>
          )
        }
      </Layout>
    </div>
  );
});
// };

export default BasicLayout;
